import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./styles.css";
import Modal from "./components/modal/Modal.jsx";
import MyProfile from "./components/Profile/MyProfile.jsx";
import MyEvents from "./components/Event/MyEvents.jsx";
import Invitation from "./components/Invitation/Invitation";
import Settings from "./components/Settings/Settings.jsx";
import { useTranslation } from 'react-i18next'
import { useDispatch } from "react-redux";
import { setOpenModal, setGuestInvitationEnabled, setMenuIsOpen, setTestModal, setMattermostChatEnabled } from "./store/controlPanelSlice.js";
import { useSelector } from "react-redux";
import Announcement from "./components/Announcemant/Announcement.jsx";
import Interact from "./components/Interact/Interact.jsx";
import MessageDialog from "./components/MessageDialog/MessageDialog.jsx";
import MessageHistory from "./components/MessageHistory/MessageHistory.jsx";
import { getUnreadConversationCount } from '../../store/messagesSlice/messagesThunks.js'
import { fetchUpcomingCount } from "./store/myEventModal/myEventModalThunks.js";
import AddEvent from "./components/AddEvent/AddEvent.jsx";
import EventType from "./components/EventType/EventType.jsx";
import ConferenceEventForm from "./components/ConferenceEvent/ConferenceEventForm/ConferenceEventForm.jsx";
import ConferenceEvent from "./components/ConferenceEvent/ConferenceEvent.jsx";
import { isGuestInvitationEnabled, getMattermostLaunchUrl, provisionMyTeam, isMattermostChatEnabled } from "./store/controlPanelThunks.js"
import socketFactory from "../../utils/socketFactory.js";
import { getInitialAvatarJSX } from "../../utils/stringUtils.js";
import { statusMap } from "../../data/statusOptions.js";
import StatusSelector from "./components/StatusSelector/StatusSelector.jsx";
import { hasPermission, tenantHasFeature } from "../Auth/utils/AuthUtils";
import UserManagement from "./components/UserManagement/UserManagement.jsx";
import SupportModal from "./components/Technical Support/SupportModal.js";
import PermissionAudioDialog from "../MediaPlayback/components/permissionAudioDialog/PermissionAudioDialog.jsx";
import ChangeMap from "./components/ChangeMap/ChangeMap.jsx";
import TestLivekit from "./components/TestLivekit/TestLivekit.jsx";
import MessageHeaderIcon from "../../assets/Chat.svg";
import MessageIcon from "../../assets/Chat-white.svg";
import SettingsIcon from "../../assets/settings.svg";

import Permission from "./components/Permission/Permission.jsx";
import ChangePhoto from "./components/Profile/ChangePhoto/ChangePhoto.jsx";
import AdjustPhoto from "./components/Profile/AdjustPhoto/AdjustPhoto.jsx";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import InfoAndSupport from "./components/Technical Support/InfoAndSupport.jsx";
import CreateSurvey from "./components/CreateSurvey/CreateSurvey.jsx";
import EndSession from "../ProductivitySession/components/EndSessionModal/EndSession.jsx";
import StopFocus from "../ProductivitySession/components/StopFocus/StopFocus.jsx";
import ChangeBruit from "../ProductivitySession/components/ChangeBruit/ChangeBruit.jsx";
import { setPauseMusic } from "../ProductivitySession/store/ProductivitySessionSlice.js";
import { he } from "date-fns/locale";
import CoffePauseProgress from "../CoffeePause/components/coffePauseProgress/coffePauseProgress.js";
import CreateSession from "../ProductivitySession/components/CreateSession/CreateSession.jsx";
import SessionProgress from "../ProductivitySession/components/SessionProgress/SessionProgress.jsx";

import {
    setShowReservationPopup,
    setUpdateRoom
} from "../Map/store/RoomMenu/RoomMenuSlice.js";
import { setInit } from "./store/Conference/CreateConferenceSlice.js";
import { resetMessageDialog } from "../../store/messagesSlice/messagesSlice.js";
import StopConferenceModal from "../Conference/components/stopConferenceModal/StopConferenceModal.jsx";
import { getDailySparks } from "./store/Spark/SparkThunks.js";
import SparkArrival from "./components/Spark/SparkArrival/SparkArrival.jsx";
import SendSparks from "./components/Spark/SendSparks/SendSparks.jsx";
import { getSparkStatus } from "../../utils/SparkUtils.js";
import UserSpark from "./components/Spark/UserSpark/UserSpark.jsx";
import SparkLeaderBoard from "./components/Spark/SparkLeaderBoard/SparkLeaderBoard.jsx";
import ReleaseNote from "./components/ReleaseNote/ReleaseNote.jsx";



const PeoplmapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    zIndex: 10009,
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#ffffff',
        color: '#000000',
        fontSize: '14px',
        borderRadius: '8px',
        padding: '8px 12px',
        fontFamily: '"Roboto", sans-serif',
        zIndex: 10009,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#ffffff',
        zIndex: 10009,
    },
}));

const iconPath = (iconName) =>
    require(`../../assets/status_icon/${iconName}.png`);

export default function ControlPanel() {
    const unreadCount = useSelector(state => state.messageHistory.UnreadConversationCount);
    const {
        sessionView
    } = useSelector((state) => state.productivitySession);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { openModal, guestInvitationEnabled, menuIsOpen, testModal, mattermostChatEnabled } = useSelector(state => state.controlPanel)
    const { conferenceMode } = useSelector(state => state.livekit);

    const {
        initialReservation
    } = useSelector((state) => state.RoomMenu);

    const { localConversations } = useSelector((state) => state.messageHistory);

  const {
        uiState    } = useSelector((state) => state.activeConference);
    
    const upcomingCount = useSelector((state) => state.myEventModal.upcomingCount);
    const upcomingCountLoading = useSelector((state) => state.myEventModal.upcomingCountLoading);

    const [activeTab, setActiveTab] = useState(0);
    const elementsPerPage = 15;

    const initRef = useRef(false)

    const showPermissionDialog = useSelector((state) => state.mediaPlayback);

    useEffect(() => {
        if (!initRef.current) {
            initRef.current = true;
            dispatch(fetchUpcomingCount());
        }
    })

    function useMobile() {
        const [isMobile, setIsMobile] = useState(window.innerWidth < 750);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 750);
            };

            window.addEventListener('resize', handleResize);

            // Nettoyage
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return isMobile;
    }

    const isMobile = useMobile();

    const tenantId = useSelector((s) => s.auth?.tenant?.id);
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const openMattermost = async () => {
        const w = window.open("", "_blank");
        const render = (text) => {
            if (!w || w.closed) return;
            w.document.open();
            w.document.write(`
      <html>
        <head><title>Configuration du chat...</title></head>
        <body style="font-family:sans-serif;padding:24px;">
          <h3>Configuration du chat…</h3>
          <p>${text}</p>
          <p style="opacity:.7">Ne fermez pas cet onglet.</p>
        </body>
      </html>
    `);
            w.document.close();
        };

        try {
            if (!tenantId) throw new Error("tenantId manquant côté front");

            render("Préparation en cours…");

            const launch = await dispatch(getMattermostLaunchUrl({ params: [{ tenantId }] })).unwrap();
            const { url: ssoUrl, teamName, baseUrl } = launch;

            let didNavigateToSso = false;

            for (let i = 0; i < 180; i++) {
                let r;
                try {
                    r = await dispatch(provisionMyTeam({ params: [{ tenantId }] })).unwrap();
                } catch (e) {
                    const httpStatus = e?.status || e?.originalStatus;
                    const data = e?.data;
                    if (httpStatus === 202 && data?.status === "WAITING_USER") {
                        r = data;
                    } else {
                        throw e;
                    }
                }

                if (r?.status === "OK") {
                    const finalUrl =
                        (baseUrl && teamName)
                            ? `${baseUrl}/${teamName}/channels/town-square`
                            : ssoUrl;

                    if (w && !w.closed) w.location.replace(finalUrl);
                    return;
                }

                if (r?.status === "WAITING_USER") {
                    if (!didNavigateToSso && w && !w.closed) {
                        render("Connexion au chat requise… Redirection vers Mattermost SSO.");
                        w.location.replace(ssoUrl);
                        didNavigateToSso = true;
                    }
                    await sleep(r?.retry_after_ms ?? 500);
                    continue;
                }

                render(`Statut inattendu: ${r?.status || "UNKNOWN"}`);
                await sleep(500);
            }
            render("Ça prend plus de temps que prévu. Veuillez réessayer.");
        } catch (e) {
            console.error("Cannot open Mattermost:", e);
            if (w && !w.closed) render(`Erreur: ${e?.data?.error || e?.message || "Erreur inconnue"}`);
        }
    };

    const handleChatClick = () => {
        if (mattermostChatEnabled) openMattermost();
        else handleOpenModal("message_history");
    };

    useEffect(() => {
        dispatch(getUnreadConversationCount());
    }, [localConversations]);

    const handleCloseCard = useCallback(() => {
        dispatch(setOpenModal(null));
        if (isMobile) {
            OpenMenu()
        }
    }, [])

    const handleCloseCardAndCleanConference = useCallback(() => {
        dispatch(setOpenModal(null));
        if (isMobile) {
            OpenMenu()
        }

        dispatch(setInit())
    }, [])

    const handleCloseCardAndPlayBruit = useCallback(() => {
        dispatch(setPauseMusic(true));
        dispatch(setOpenModal(null));
        if (isMobile) {
            OpenMenu()
        }
    }, []
    )
    const handleCloseTestModal = useCallback(() => {
        dispatch(setTestModal(null));
    }, [])
    const handleCloseMessageHistory = () => {
        // Reset immédiat AVANT fermeture du popup
        dispatch(resetMessageDialog());
        dispatch({ type: "messageHistory/clearMessages" });
        dispatch({ type: "messageHistory/setSelectedConversationId", payload: null });
        dispatch({ type: "messageHistory/setChatPartner", payload: null });

        // Ensuite seulement fermer le popup
        dispatch(setOpenModal(null));
    };


    const toggleMenu = () => {
        const newState = !menuIsOpen;;
        setMenuIsOpen(newState);
        dispatch(setMenuIsOpen(newState));
        document.body.classList.toggle('main-menu-open', newState);
    };


    const OpenMenu = () => {
        setMenuIsOpen(true);
        dispatch(setMenuIsOpen(true));
        document.body.classList.add('main-menu-open');
    };

    const CloseMenu = () => {
        setMenuIsOpen(false);
        dispatch(setMenuIsOpen(false));
        document.body.classList.remove('main-menu-open');
    };

    const handleChangeTab = (newTab) => {
        setActiveTab(newTab);
    }

    const handleOpenModal = (modalName) => {
        dispatch(setOpenModal(modalName));
        if (isMobile) CloseMenu();
    };

    const { localAvatar } = useSelector((state) => state.auth);
    const {
        DailySparks,
        MySparks
    } = useSelector((state) => state.Spark);
    const { openModal: AuthOpenModal } = useSelector((state) => state.auth);
    const currentUserID = localAvatar?.id;
    //Mock DATA
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    useEffect(() => {
        const fetchGuestInvitationPermission = async () => {
            try {
                const guestInvitationPermission = await dispatch(isGuestInvitationEnabled()).unwrap();
                dispatch(setGuestInvitationEnabled(guestInvitationPermission));
                const mmChat = await dispatch(isMattermostChatEnabled()).unwrap();
                dispatch(setMattermostChatEnabled(mmChat));
            } catch (error) {
                console.error("Erreur lors de la récupération des permissions d'invitation :", error);
            }
        };
        fetchGuestInvitationPermission();

    }, [menuIsOpen]);

    const currentStatus = useMemo(() => {
        const status = statusMap[localAvatar?.user_status];
        if (!status) return null;
        return status;
    }, [localAvatar]);

    const handleEventTypeClick = (type) => {
        if (type === "scheduled_meeting") {
            dispatch(setUpdateRoom(false));
            dispatch(setShowReservationPopup(true));
            dispatch(setOpenModal("create_an_event"));
        } else {
            dispatch(setUpdateRoom(false));
            dispatch(setOpenModal("create_conference"));
        }
    };

    const dailySparksInitFetchedRef = useRef(false);

    const checkAndOpenDailySparksModal = useCallback(() => {

        if (Number(DailySparks) !== 6) return;
        if (AuthOpenModal) return;
        if (openModal === "new_daily_sparks") return;

        const today = new Date();
        const todayKey = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        const lastLogin = localStorage.getItem("LastLoginDate");

        if (lastLogin === todayKey) return;

        dispatch(setOpenModal("new_daily_sparks"));
        localStorage.setItem("LastLoginDate", todayKey);
    }, [DailySparks, AuthOpenModal, openModal, dispatch]);

    // Fetch sparks once per day
    useEffect(() => {
        if (!localAvatar?.id) return;
        if (dailySparksInitFetchedRef.current) return;

        dailySparksInitFetchedRef.current = true;
        dispatch(getDailySparks({ params: [{ user_id: localAvatar.id }] }));
    }, [localAvatar?.id]);

    // Try to open modal whenever sparks amount changes
    useEffect(() => {
        if(tenantHasFeature("SPARKS_SYSTEM_ENABLED")){
        checkAndOpenDailySparksModal();
        }

    }, [DailySparks ,AuthOpenModal ]);

    const { label, icon } = getSparkStatus(MySparks);

    const openUserSpark = () => {
        dispatch(setOpenModal("User_Spark"));
    }
    return (
        <>
            <div className="index-content">
                <div className={`config-menu ${menuIsOpen ? 'config-menu-open' : ''}`}
                    onMouseEnter={!isMobile ? () => OpenMenu() : undefined}
                    onMouseLeave={!isMobile ? () => CloseMenu() : undefined}>
                    <div className="view-profile">
                        <span className="go-back-menu" onClick={isMobile ? () => toggleMenu() : undefined}>
                            <span class="material-symbols-outlined">
                                chevron_backward
                            </span>
                        </span>
                        <span className="bg-avatar"
                            style={{
                                overflow: 'unset',
                                position: 'relative',
                                display: 'inline-block',
                                flexShrink: 0,
                            }}
                            onClick={isMobile ? () => toggleMenu() : undefined}>
                            {localAvatar?.urlphoto === "Avatar.png" ?
                                getInitialAvatarJSX(
                                    localAvatar?.firstName,
                                    localAvatar?.lastName,
                                )
                                :
                                <img
                                    alt="User Avatar"
                                    src={localAvatar?.urlphoto}
                                    sx={{
                                        width: 128,
                                        height: 128,
                                        borderRadius: "50%",
                                        marginTop: "20px",
                                        marginBottom: "8px",
                                    }}
                                />
                            }
                            {(currentStatus.type === 'mui' && currentStatus.value != 0) || currentStatus.value != 0 ? (
                                <span
                                    style={{
                                        position: 'absolute',
                                        top: '-4px',
                                        right: '-4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 1,
                                    }}
                                >
                                    {currentStatus.type === 'mui' ? (
                                        (() => {
                                            const Icon = currentStatus.IconComponent;
                                            return (
                                                <Icon
                                                    sx={{
                                                        fontSize: '1rem',
                                                        color: currentStatus.color,
                                                        borderRadius: '50%',
                                                    }}
                                                />
                                            );
                                        })()
                                    ) : (
                                        <img
                                            src={iconPath(currentStatus.iconName)}
                                            alt={currentStatus.labelKey}
                                            style={{
                                                height: '1rem',
                                                width: 'auto',
                                                borderRadius: '50%',
                                            }}
                                        />
                                    )}
                                </span>
                            ) : null}
                        </span>
                        <div className="profile-name">
                            <PeoplmapTooltip title={localAvatar?.is_guest ? localAvatar?.display_name : localAvatar?.name} arrow>
                                <span className="name">
                                    {
                                        localAvatar?.is_guest
                                            ? localAvatar?.display_name
                                            : localAvatar?.name
                                    }
                                </span>
                            </PeoplmapTooltip>
                            <div className="status">
                                 {tenantHasFeature("SPARKS_SYSTEM_ENABLED") &&(
                                <span className="user-spark-status" onClick={openUserSpark}>
                                    <img
                                        src={icon}
                                        alt={label}
                                        className="user-spark-icon"

                                    />
                                    <span className="user-spark-label">{t(label)}</span>
                                </span> )}
                                <span
                                    className={`material-symbols-outlined cursor-pointer ${menuIsOpen ? 'is-open' : ''}`}
                                    onClick={isMobile ? () => toggleMenu() : undefined}
                                >
                                    keyboard_arrow_down
                                </span>
                                {
                                    openModal === "status_selector" && (<StatusSelector></StatusSelector>)
                                }
                            </div>
                        </div>
                    </div>
                    <div className={`config-items ${menuIsOpen ? 'open' : ''}`}>
                        <ul>
                            <li className="item-config" onClick={() => handleOpenModal("my_profile")}>
                                <span className="material-symbols-outlined">
                                    person
                                </span>
                                {t("my_profile")}
                            </li>

                            {hasPermission("interact") && (<li className="item-config" onClick={() => handleOpenModal("interact")}>
                                <span className="material-symbols-outlined">
                                    groups
                                </span>
                                {t("interact")}
                            </li>)}
{/*
                            {tenantHasFeature("USER_CHAT_ENABLED") && hasPermission("messageHistory") && (
                                <li className="item-config" data-tour="messages" onClick={handleChatClick}>
                                    <img src={MessageHeaderIcon} alt="chat" className="menu-chat-icon" />
                                    {t("message_history")}
                                    {unreadCount > 0 && <span className="unread-msg-count">{unreadCount}</span>}
                                </li>
                            )}
*/}
                            <li className="item-config" onClick={() => handleOpenModal("my_schedule")}>
                                <span className="material-symbols-outlined">
                                    calendar_today
                                </span>
                                {t("my_schedule")}
                                {!upcomingCountLoading && upcomingCount > 0 && (
                                    <span className="unread-msg-count">{upcomingCount}</span>
                                )}
                            </li>

                            {tenantHasFeature("GUEST_INVITATION_ENABLED") && hasPermission("invitePeople") &&
                                (<li className="item-config" data-tour="invite" onClick={() => handleOpenModal("invite_users")}>
                                    <span className="material-symbols-outlined">
                                        person_add
                                    </span>
                                    {t("invite_users")}
                                </li>)
                            }

                            <li className="item-config" onClick={() => handleOpenModal("settings")}>
                                <span className="settings-icon-wrapper">
                                    <img src={SettingsIcon} alt="msg" />
                                </span>
                                {t("settings")}
                            </li>


                            {tenantHasFeature("OPEN_PROJECT_SUPPORT") &&
                                <li className="item-config" onClick={() => handleOpenModal("info&support")}>
                                    <span className="material-symbols-outlined">
                                        help
                                    </span>
                                    {t("support")}
                                </li>
                            }

                            {(
                                (tenantHasFeature("SPEAK_TO_ALL_ENABLED") && hasPermission("globalAnnouncement")) ||
                                (tenantHasFeature("USER_MANAGEMENT_ENABLED") && hasPermission("permissionManagement"))) && (
                                    <>
                                        <span className="sep-menue">
                                            <span className="left-sep-menu"></span>
                                            <span className="name-sep-menu">{t("administration")}</span>
                                            <span className="right-sep-menu"></span>
                                        </span>

                                        {(tenantHasFeature("SPEAK_TO_ALL_ENABLED") && hasPermission("globalAnnouncement")) && (
                                            <li className="item-config" onClick={() => handleOpenModal("make_an_announcement")}>
                                                <span className="material-symbols-outlined">campaign</span>
                                                {t("make_an_announcement")}
                                            </li>
                                        )}

                                        {(tenantHasFeature("USER_MANAGEMENT_ENABLED") && hasPermission("permissionManagement")) && (
                                            <li className="item-config" onClick={() => handleOpenModal("manage_users")}>
                                                <span className="material-symbols-outlined">person_edit</span>
                                                {t("manage_users")}
                                            </li>
                                        )}
                                    </>
                                )}

                        </ul>
                    </div>
                </div>

                {!isMobile && (
                    <div className={`coffe-session-actions ${sessionView === "progress" ? "session-active" : ""}`}
                        style={{ display: conferenceMode ? 'none' : '' }}>
                        <CreateSession />
                        <SessionProgress />
                        <CoffePauseProgress />

                    </div>
                )
                }
            </div>



            {isMobile && (
                <div className="coffe-session-progress">
                    <CreateSession />
                    <SessionProgress />
                    <CoffePauseProgress />
                </div>

            )
            }
            {openModal === "my_profile" && (
                <Modal
                    isOpen={true}
                    headerIcon={"person"}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("my_profile")}
                    className={'paper paper-profile'}

                >
                    <MyProfile
                        localAvatar={localAvatar}
                    />
                </Modal>
            )}

            {hasPermission("interact") && openModal === "interact" && (
                <Modal
                    isOpen={true}
                    headerIcon={"groups"}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("interact")}
                    className={'paper'}                >
                    <Interact
                        isChatEnabled={true}
                        isGroupMessageEnabled={true}
                    />
                </Modal>
            )}
{ ( !uiState.is_conference_active  && 
   <div className={`open-msg-icon ${openModal == 'message_history' ? 'msg-panel-open' : 'msg-panel-closed'}`}
                onClick={handleChatClick}>
                <span className="msg-icon-wrapper">
                    <img src={MessageIcon} alt="msg" />
                </span>
                {unreadCount > 0 && <span className="msg-unread-count">{unreadCount}</span>}
            </div>

)}




         

            {tenantHasFeature("USER_CHAT_ENABLED") && hasPermission("messageHistory") && openModal === "message_history" && (
                <MessageHistory
                    onClose={handleCloseMessageHistory}
                    className={'dialog-container msg-history'}
                    localAvatar={localAvatar}
                    currentUserID={currentUserID} />

            )}

            {openModal === "my_schedule" && (
                <Modal
                    isOpen={true}
                    headerIcon={"calendar_today"}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("my_schedule")}
                    className={'paper'}
                >
                    <MyEvents />
                </Modal>
            )}

            {tenantHasFeature("GUEST_INVITATION_ENABLED") && hasPermission("invitePeople") && openModal === "invite_users" && (
                <Modal
                    isOpen={true}
                    headerIcon={"person_add"}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("invite_users")}
                    className={'paper'}
                >
                    <Invitation
                        onClose={() => {
                            dispatch(setOpenModal(null));
                            if (isMobile) {
                                OpenMenu()
                            }
                        }
                        }

                    />
                </Modal>
            )}

            {openModal === "settings" && (
                <Modal
                    isOpen={true}
                    headerIcon={"manage_accounts"}
                    onClose={handleCloseCard}
                    header={t("settings")}
                    className={'paper settings-paper'}
                >
                    <Settings
                        onClose={() => {
                            dispatch(setOpenModal(null))
                            if (isMobile) {
                                OpenMenu()
                            }
                        }}
                    />
                </Modal>
            )}

            {(tenantHasFeature("SPEAK_TO_ALL_ENABLED") && hasPermission("globalAnnouncement")) && (openModal === "make_an_announcement") && (
                <Modal
                    isOpen={true}
                    headerIcon={"campaign"}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("activating_global_announcement")}
                    className={'paper'}

                >
                    <Announcement
                        onCancel={handleCloseCard}
                    />
                </Modal>
            )}

            {(tenantHasFeature("USER_MANAGEMENT_ENABLED") && hasPermission("permissionManagement")) && openModal === "manage_users" && (
                <UserManagement />
            )}

            {
                openModal === "message_dialog" && (
                    <MessageDialog
                        className={'message-dialog'}
                    />
                )
            }

            {openModal === "event_type" && (
                <EventType isOpen={true}
                    onClose={handleCloseCard}
                    onSelect={handleEventTypeClick}
                />
            )}

            {openModal === "create_conference" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCardAndCleanConference}
                    size={"lg"}
                    header={t("create_conference")}
                    className={'make-event create_conference-popup'}
                    headerIcon={"create_conference"}
                >
                    <ConferenceEventForm onClose={handleCloseCardAndCleanConference} />
                </Modal>
            )}

            {openModal === "update_conference" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCardAndCleanConference}
                    size={"lg"}
                    header={initialReservation?.title}
                    className={'make-event update_conference-popup'}
                    headerIcon={"create_conference"}
                >
                    <ConferenceEvent onClose={handleCloseCardAndCleanConference} />
                </Modal>
            )}

            {openModal === "create_an_event" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("create_an_event")}
                    className={'make-event reservation-popup'}
                    headerIcon={"calendar_month"}
                >
                    <AddEvent onClose={handleCloseCard} />
                </Modal>
            )}
            {openModal === "stop-conference" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"md"}
                    header={t("stop-conference")}
                    className={'paper paper-profile'}
                    headerIcon={"login"}
                >
                    <StopConferenceModal onClose={handleCloseCard} />
                </Modal>
            )}

            {openModal === "update_an_event" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("update_an_event")}
                    className={'reservation-popup make-event'}
                    headerIcon={"calendar_month"}
                >
                    <AddEvent
                        onClose={handleCloseCard}
                    />
                </Modal>
            )}
            {openModal === "support" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("report_problem")}
                    headerIcon={"error"}
                    className={'paper'}
                >
                    <SupportModal
                        onClose={handleCloseCard}


                    />
                </Modal>
            )}
                        {openModal === "release_note" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("release_note")}
                    headerIcon={"release_alert"}
                    className={'paper'}
                >
                    <ReleaseNote
                        onClose={handleCloseCard}


                    />
                </Modal>
            )}
            {
                openModal === "message_dialog" && (
                    <MessageDialog
                        className={'message-dialog'}
                    />
                )
            }
            {showPermissionDialog && openModal === "permission_audio_dialog" && (

                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("audio_permission")}
                    headerIcon={"sound_detection_loud_sound"}
                >
                    <PermissionAudioDialog
                    />
                </Modal>
            )}
            {openModal === "confirm_change_map" && (
                <Modal
                    isOpen={true}
                    headerIcon={"groups"}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("change_map")}
                    className={'paper'}                >
                    <ChangeMap
                        onClose={handleCloseCard} />

                </Modal>
            )}
            {testModal === "livekit_tester" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseTestModal}
                    size={"lg"}
                    header={t("livekit_test")}
                    headerIcon={"network_ping"}
                    className={'paper'}
                >
                    <TestLivekit
                        onClose={handleCloseTestModal} />
                </Modal>

            )}
            {testModal === "mic_permission" && (
                <Modal
                    isOpen={true}
                    headerIcon={"settings_alert"}
                    onClose={handleCloseTestModal}
                    size={"lg"}
                    header={t("mic_permission")}
                    className={'paper'}>
                    <Permission
                        onClose={handleCloseTestModal}
                        Text="mic_permission_text"
                    />
                </Modal>
            )}
            {testModal === "camera_permission" && (
                <Modal
                    isOpen={true}
                    headerIcon={"settings_alert"}
                    onClose={handleCloseTestModal}
                    size={"lg"}
                    header={t("cam_permission")}
                    className={'paper'}>
                    <Permission
                        Text="cam_permission_text"
                    />
                </Modal>
            )}
            {openModal === "take_photo" && (
                <Modal
                    isOpen={true}
                    headerIcon={""}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("take_photo")}
                    className={'paper'}>
                    <ChangePhoto
                        onClose={handleCloseCard} />

                </Modal>
            )}
            {openModal === "adjust_photo" && (
                <Modal
                    isOpen={true}
                    headerIcon={""}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("adjust_photo")}
                    className={'paper'}>
                    <AdjustPhoto
                        onClose={handleCloseCard} />

                </Modal>
            )}
            {openModal === "info&support" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("support")}
                    headerIcon={"help"}
                    className={'paper'}
                >
                    <InfoAndSupport
                        onClose={handleCloseCard}
                    />
                </Modal>
            )}
            {openModal === "vote" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"lg"}
                    header={t("create_survey")}
                    headerIcon={"how_to_vote"}
                    className={'paper'}
                >
                    <CreateSurvey
                        onClose={handleCloseCard}
                    />
                </Modal>
            )}
            {openModal === "user_in_focus" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"sm"}
                    headerIcon={"headphones"}
                    className={'paper paper-profile'}
                >
                    <EndSession
                        onClose={handleCloseCard}
                    />
                </Modal>
            )}
            {openModal === "stop_focus" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    size={"sm"}
                    headerIcon={"headphones"}
                    className={'paper paper-profile'}
                >
                    <StopFocus
                        onClose={handleCloseCard}
                    />
                </Modal>
            )}
            {openModal === "track_selection" && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCardAndPlayBruit}
                    size={"xs"}
                    headerIcon={"headphones"}
                    header={t("change_bruit_title")}
                    className={'paper paper-profile'}
                    PaperProps={{
                        sx: {
                            width: "362px !important",
                            maxWidth: "90vw !important",
                            height: "fit-content !important"
                        }
                    }}
                >
                    <ChangeBruit
                        onClose={handleCloseCardAndPlayBruit}
                    />
                </Modal>
            )}
            {openModal === "new_daily_sparks" && (
                <SparkArrival
                    onClose={handleCloseCard}
                />
            )}
            {openModal === "SendSparks" && (
                <SendSparks
                    onClose={handleCloseCard}
                />
            )}
            {openModal === "User_Spark" && (
                <UserSpark
                    onClose={handleCloseCard}
                />
            )}
            {openModal === "Spark_leaderboard" && (
                <SparkLeaderBoard
                    onClose={handleCloseCard}
                />
            )}
        </>
    )
}
